// Placeholders for future server integration.
// https://calendlyapp.atlassian.net/browse/TAS-533
// https://calendlyapp.atlassian.net/browse/TAS-479

export const verifyPhoneCode = (_code) => async () => {}

export const resendPhoneVerificationCode = () => async () => {}

export const skipPhoneVerification = () => async () => {}
